<pas-system-process [cancelButton]="false" #processComponentAttachment></pas-system-process>
<!-- Originally we had ag-grid fixed height set to 300px, regardless of row number
To avoid empty space in bottom area, if row count is less than 8 (this fits in 300px), height is calculated automatically -->
<ag-grid-angular
  [gridOptions]="gridOptions"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [components]="frameworkComponents"
  [animateRows]="true"
  (gridReady)="onGridReady($event)"
  (gridSizeChanged)="onGridSizeChanged($event)"
  class="ag-theme-alpine_customize"
  id="attachmentsTable"
  domLayout="autoHeight"
  style="width: 100%; height: none"></ag-grid-angular>
